import { Defs, LinearGradient, Path, Stop, Svg } from '@react-pdf/renderer'
import React from 'react'

export const GradientStripe = () => (
  <Svg width='96' height='4' viewBox='0 0 96 4' fill='none'>
    <Path
      d='M1.93523e-07 4L96 4V7.55146e-08L0.0278537 7.55146e-08C0.027836 0.410924 2.07416e-05 3.3753 1.93523e-07 4Z'
      fill='url(#paint0_linear_1_2)'
    />
    <Defs>
      <LinearGradient
        id='paint0_linear_1_2'
        x1='0.0119173958'
        y1='1.648545'
        x2='0.8871614583'
        y2='-5.8283'>
        <Stop offset='0%' stopColor='#E55812' />
        <Stop offset='26.7347%' stopColor='#EBFF00' />
        <Stop offset='55.1915%' stopColor='#00FF85' />
        <Stop offset='76.0417%' stopColor='#06D6A0' />
        <Stop offset='100%' stopColor='#1B43AA' />
      </LinearGradient>
    </Defs>
  </Svg>
)
